var map = {
	"./Logo_mineria_blanco.png": 9124,
	"./add_icon.svg": 8735,
	"./administration_cards/administration_equips_card_en.jpg": 8707,
	"./administration_cards/administration_equips_card_es.jpg": 554,
	"./administration_cards/administration_sensors_card_en.jpg": 1593,
	"./administration_cards/administration_sensors_card_es.jpg": 256,
	"./administration_cards/administration_transfers_card_en.jpg": 6936,
	"./administration_cards/administration_transfers_card_es.jpg": 5393,
	"./administration_cards/administration_users_card_en.jpg": 188,
	"./administration_cards/administration_users_card_es.jpg": 6765,
	"./administration_cards/administration_worksites_card_en.jpg": 5769,
	"./administration_cards/administration_worksites_card_es.jpg": 7008,
	"./battery.svg": 4759,
	"./black_battery.svg": 3003,
	"./card_logo.png": 7635,
	"./cards.svg": 6757,
	"./close.svg": 8980,
	"./danger.svg": 4321,
	"./delete.svg": 7513,
	"./delete_icon.svg": 8183,
	"./diagram.svg": 6127,
	"./diagrams/AMSA ANTUCOYA.jpg": 1118,
	"./diagrams/SMTEC.jpg": 5008,
	"./download_report.svg": 2385,
	"./edit.svg": 6100,
	"./en.svg": 2785,
	"./en_disabled.png": 2203,
	"./en_enabled.png": 5168,
	"./es.svg": 6743,
	"./es_disabled.png": 7276,
	"./es_enabled.png": 1073,
	"./list.svg": 8632,
	"./locale_setting.png": 6736,
	"./login_tecnipak.jpeg": 5809,
	"./logo-flat.png": 6372,
	"./logo-flat_old.png": 1346,
	"./logo.png": 4010,
	"./logo_old.png": 1112,
	"./logo_telepak.svg": 2992,
	"./logo_telepak_old.svg": 5338,
	"./logout.png": 2621,
	"./map.svg": 146,
	"./notifications_levels/0.svg": 2787,
	"./notifications_levels/1.svg": 4850,
	"./notifications_levels/2.svg": 9889,
	"./psi.svg": 1216,
	"./save.svg": 8167,
	"./sidebar_image.svg": 9906,
	"./signal.svg": 7044,
	"./user.png": 6422,
	"./util.svg": 3244,
	"./util_life.svg": 1913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;